export enum PLATFORMS {
	IOS = 'ios',
	ANDROID = 'android',
	WEB = 'web',
}
